import { useContext, useState } from "react";
import { IconThreeDots } from "antopolis-react-icons";
import { useGetInfo } from "antopolis-react-utils/hooks";

import { useUseOrientation } from "../../../../../Utilities/Hooks/useUseOrientation";
import { useAxiosInstance } from "../../../../../Utilities/Hooks/useAxiosInstance";
import { CreateButton } from "../../../../Partials/Layout/CRUD/CreateButton/CreateButton";
import { CRUDTable } from "../../../../Partials/Layout/CRUD/CRUDTable/CRUDTable";
import { CRUDTableHeader } from "../../../../Partials/Layout/CRUD/CRUDTableHeader/CRUDTableHeader";
import { CRUDth } from "../../../../Partials/Layout/CRUD/CRUDth/CRUDth";
import { ImageCell } from "../../../../Partials/Layout/CRUD/ImageCell/ImageCell";
import {
  EditButton,
  ViewButton,
} from "../../../../Partials/Layout/CRUD/CRUDButtons/CRUDButtons";
import { Modal } from "../../../../Partials/Elements/Modal/Modal";
import { LayoutContext } from "../../../../../Contexts/GlobalContexts/LayoutContext";

import ViewSocialLink from "./ViewSocialLink";
import CreateSocialLink from "./CreateSocialLink";
import UpdateSocialLink from "./UpdateSocialLink";

function SocialLinks({api}) {
  const [showActionButton, setShowActionButton] = useState(false);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [showUpdateForm, setShowUpdateForm] = useState(false);
  const [showViewSection, setShowViewSection] = useState(false);

  const [targetID, setTargetID] = useState(null);

  const { portrait } = useUseOrientation();
  const axiosInstance = useAxiosInstance();
  const { toggleFetch } = useContext(LayoutContext);

  const { info: socialLinks } = useGetInfo({
    axiosInstance: axiosInstance,
    api: api + "getAllSocailLinks",
    toggleFetch,
  });

  console.log(socialLinks);

  return (
    <div className="screen_wrapper">
      <div className="screen_header">
        <h1 className="screen_heading">
          Social Links ({socialLinks?.length} in total)
        </h1>
        <CreateButton
          screenTopicSingular={"Social Link"}
          setShowCreateForm={setShowCreateForm}
        />
      </div>
      <CRUDTable>
        <CRUDTableHeader>
          <CRUDth th="Name" />
          <CRUDth th="Link" />
          <CRUDth th="Actions" />
        </CRUDTableHeader>
        <tbody>
          {socialLinks?.map((socialLink) => (
            <tr key={socialLink._id}>
             <td>{socialLink.name}</td>
             <td>{socialLink.link}</td>
              <td>
                <div className="action_buttons_wrapper">
                  <button
                    className="three_dots"
                    onClick={() => {
                      if (targetID === socialLink._id) {
                        setTargetID("");
                      } else {
                        setShowActionButton(true);
                        setTargetID(socialLink._id);
                      }
                    }}
                  >
                    <IconThreeDots />
                  </button>
                  {!portrait && (
                    <div className="action_buttons">
                      <ViewButton
                        setShowViewSection={setShowViewSection}
                        targetID={socialLink._id}
                        setTargetID={setTargetID}
                      />
                      <EditButton
                        setShowUpdateForm={setShowUpdateForm}
                        targetID={socialLink._id}
                        setTargetID={setTargetID}
                      />
                    </div>
                  )}
                  {portrait &&
                    showActionButton &&
                    targetID === socialLink._id && (
                      <div className="action_buttons">
                        <ViewButton
                          setShowViewSection={setShowViewSection}
                          targetID={socialLink._id}
                          setTargetID={setTargetID}
                        />
                        <EditButton
                          setShowUpdateForm={setShowUpdateForm}
                          targetID={socialLink._id}
                          setTargetID={setTargetID}
                          setShowActionButton={setShowActionButton}
                        />
                      </div>
                    )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>

        {/* <Pagination
          totalPages={totalPages}
          totalItems={totalClients}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
        /> */}
      </CRUDTable>

      {showCreateForm && (
        <Modal
          extraClass={"small"}
          modalHeading={`Create Social Link`}
          setShowModalContent={setShowCreateForm}
        >
          <CreateSocialLink setShowCreateForm={setShowCreateForm} api={api} targetID={targetID} />
        </Modal>
      )}
      {showUpdateForm && (
        <Modal
          extraClass={"small"}
          modalHeading={`Update Social Link`}
          setShowModalContent={setShowUpdateForm}
        >
          <UpdateSocialLink
            setShowUpdateForm={setShowUpdateForm}
            targetID={targetID}
          />
        </Modal>
      )}
      {/* 

      {showUpdateForm && (
        <Modal
          extraClass={"small"}
          modalHeading={`Update Client`}
          setShowModalContent={setShowUpdateForm}
        >
          <UpdateClient
            employee={employee}
            triggerFetch={triggerFetch}
            targetID={targetID}
            setShowUpdateForm={setShowUpdateForm}
          />
        </Modal>
      )}

      {showViewSection && (
        <Modal
          extraClass={"small"}
          modalHeading={`View Client`}
          setShowModalContent={setShowViewSection}
        >
          <ViewClient triggerFetch={triggerFetch} targetID={targetID} />
        </Modal>
      )} */}

      {showViewSection && (
        <Modal
          extraClass={"small"}
          modalHeading={`View Social Link`}
          setShowModalContent={setShowViewSection}
        >
          <ViewSocialLink targetID={targetID} />
        </Modal>
      )}
    </div>
  );
}

export default SocialLinks;
